import { render, staticRenderFns } from "./DistrictSearch.vue?vue&type=template&id=682f1664&scoped=true&"
import script from "./DistrictSearch.vue?vue&type=script&lang=js&"
export * from "./DistrictSearch.vue?vue&type=script&lang=js&"
import style0 from "./DistrictSearch.vue?vue&type=style&index=0&id=682f1664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f1664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
